<!-- Copyright (C) 2025 Skylark Drones -->

<template>
  <v-menu
    :value="showMenu"
    offset-y
    close-delay="50"
    nudge-bottom="4"
    :content-class="'rounded-lg2 overflow-hidden'"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" icon @click="openMenu">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <template v-for="(item, idx) in menuItems">
        <v-list-item :key="idx" @click="item.clickHandler">
          <v-list-item-icon class="mr-3">
            <v-icon v-if="item.prependIcon">{{ item.prependIcon }}</v-icon>
            <img
              v-else-if="item.prependImage"
              :src="item.prependImage"
              height="24"
              width="24"
            />
          </v-list-item-icon>

          <v-list-item-title>{{ item.title }}</v-list-item-title>

          <v-list-item-icon v-if="item.appendIcon" class="ml-1">
            <v-icon>{{ item.appendIcon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-divider v-if="idx < menuItems.length - 1" :key="idx" />
      </template>
      <template v-if="DEV_TOOLS">
        <v-divider />
        <v-list-item @click="$emit('stop-livestreams')">
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-stop-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title> Stop Livestream </v-list-item-title>
          <v-list-item-action class="flex-shrink-0">
            <v-chip color="black" pill text-color="white" small class="px-2">
              DEV
            </v-chip>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { mapMutations } from 'vuex'

import GoogleMapsIcon from '@/assets/images/gmaps.png'
import { DEV_TOOLS } from '@/constants'

export default {
  name: 'DockActionsMenu',

  props: {
    dock: { type: Object, required: true }
  },

  data() {
    return {
      DEV_TOOLS,
      showMenu: false,
      menuItems: [
        {
          title: 'Copy Dock Location',
          prependIcon: 'mdi-content-copy',
          clickHandler: this.copyDockCoordinates
        },
        {
          title: 'Navigate To Dock',
          prependImage: GoogleMapsIcon,
          appendIcon: 'mdi-arrow-top-right-thin',
          clickHandler: this.navigateToDock
        },
        {
          title: 'Edit Dock Callsign',
          prependIcon: 'mdi-pencil',
          clickHandler: () => this.$emit('edit', 'call_sign')
        },
        {
          title: 'Edit Location',
          prependIcon: 'mdi-home-edit-outline',
          clickHandler: () => this.$emit('edit', 'location')
        }
      ]
    }
  },

  methods: {
    ...mapMutations(['updateNotificationPayload']),
    async copyDockCoordinates() {
      await navigator.clipboard.writeText(
        this.$props.dock.location_coordinates.toReversed()
      )
      this.updateNotificationPayload({
        message: 'Dock location copied to clipboard',
        code: 201,
        timeout: 5000
      })
    },
    navigateToDock() {
      const [lng, lat] = this.$props.dock.location_coordinates
      const baseUrl = 'https://www.google.com/maps/dir/?api=1&'
      const travelMode = 'driving'
      const url = `${baseUrl}&destination=${lat},${lng}&travelmode=${travelMode}`
      window.open(url, '_blank')
    },

    openMenu(event) {
      event.preventDefault()
      this.showMenu = true
    }
  }
}
</script>
